import { WebPlaySettings } from '@playbooks/web-play-component'

/**
 * Adds custom CSS files to the web play. (#12326, #12382)
 * @param webPlayInfoResp The web play settings containing custom CSS file URLs.
 */
export async function addWebPlayCustomCss(webPlayInfoResp: WebPlaySettings) {
  try {
    const cssLinks = webPlayInfoResp.customCssFiles?.split(',') ?? []

    for (const cssLink of cssLinks) {
      await applyCss(document.body, cssLink)
    }
  } catch (ex) {
    console.error(ex)
  }
}

async function applyCss(root: Element, cssUrl: string) {
  if (!isValidUrl(cssUrl)) {
    return
  }

  const response = await fetch(cssUrl)
  const cssText = await response.text()

  const style = document.createElement('style')
  style.textContent = cssText

  root.appendChild(style)
}

function isValidUrl(href: string) {
  try {
    new URL(href)
    return true
  } catch (_) {
    return false
  }
}
